import { Layout } from "@vwfs-bronson/bronson-react";
import SignInForm from "../../components/authentication/signInPage/SignInForm";
import SignInHeader from "../../components/authentication/signInPage/SignInHeader";
import { useEffect } from "react";
import { trackOnAuthenticationPage } from "../../adobeTracking/trackers";
import { StepsWizard } from "../../components/common/StepsWizard";

export const SignInPage = () => {
  useEffect(() => {
    trackOnAuthenticationPage();
  }, []);

  return (
    <Layout center>
      <StepsWizard activeStep={1} />
      <SignInHeader />
      <SignInForm />
    </Layout>
  );
};
